import { useAtomValue } from 'jotai'
import React from 'react'

import { type DocumentImage } from '~/gql/graphql'
import { FigureInfoHelpers } from '~/utils'

import { auth0UserAtom } from '../atoms'

/**
 * FigureMeta を作成する関数を返すカスタムフックです。
 *
 * @returns FigureMeta を作成する関数。
 */
export const useGetFigureMeta = () => {
  const auth0User = useAtomValue(auth0UserAtom)

  return React.useCallback(
    <TDocumentImage extends App.PickGraphQL<DocumentImage, 'allMetadata'>>(
      documentImage: TDocumentImage,
    ) =>
      FigureInfoHelpers.createFigureMeta({
        documentImage,
        currentUserEmail: auth0User?.email,
      }),
    [auth0User?.email],
  )
}
